Vue.component("backgroundMedia", {
    props: ["config"],
    template: `
        <div class="backgroundMedia" :style="[wrapperPosition, getPerspective]">
            <div class="backgroundMedia__wrapper" :style="[skewValues, getSize, hasLink]" @click="goto" v-if="hasSrc">
                <video :src="videoDirectory + config.src.src" 
                    v-if="config.src.src.includes('mp4')" 
                    muted 
                    autoplay 
                    loop 
                    playsinline>
                </video>
                <img :src="imgDirectory + config.src.src" v-else>


                <div class="backgroundMedia__playbutton" v-if="config.showButton === 'play'">
                    <img src="assets/img/ui/play.svg">
                </div>
            </div>
        </div>
    `,
    data() {
        return {
            imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || '',
            videoDirectory: config.BACKGROUND_VIDEO_DIRECTORY || ''
        }
    },
    methods: {
        goto() {





            if (this.config.sceneRoute !== null) {
                console.log('GOTOSCENE', this.config.sceneRoute);

                var route = false;
                var sceneInfo = touchKit.PageManager.sceneInfo(this.config.sceneRoute);

                if (sceneInfo.route) {
                    route = '/' + sceneInfo.route;
                }

                if (route && this.$route.path !== route) {
                    this.$router.push(route);
                }
            } else if (this.config.contentRoute !== null) {
                var currentRoute = this.$router.currentRoute.path;

                var currentRouteWithoutContent = currentRoute.split(':')[0];

                var routeWithContent = currentRouteWithoutContent + ':' + this.config.contentRoute;

                if (currentRoute !== routeWithContent) {
                    this.$router.push(routeWithContent);
                } else {
                    this.$router.push(currentRouteWithoutContent);
                }

            } else if (this.config.hasOwnProperty("link") && this.config.link !== "") {
                window.open(this.config.link, "_blank")
            }
        }
    },
    computed: {
        hasSrc() {
            return this.config.src !== null
        },
        getSize() {
            return {
                height: this.config.height,
                width: this.config.width
            }
        },
        wrapperPosition() {
            return {
                left: this.config.positionX + 'px',
                top: this.config.positionY + 'px'
            }
        },
        hasLink() {
            return {
                cursor: this.config.link !== "" || this.config.sceneRoute !== null || this.config.contentRoute !== null ? 'pointer' : 'auto'
            }
        },


        //SKEW
        hasSkew() {
            return this.config.hasOwnProperty("skew");
        },
        skewValues() {
            if (this.hasSkew === true) {
                return {
                    transform: 'rotate3d(' + this.config.skew.rotateX + ',' + this.config.skew.rotateY + ',' + this.config.skew.rotateZ + ',' + this.config.skew.angle + ') skew(' + this.config.skew.skewX + ', ' + this.config.skew.skewY + ')'
                }
            } else {
                return
            }
        },
        getPerspective() {
            if (this.hasSkew === true) {
                return {
                    perspective: this.config.skew.perspective
                }
            } else {
                return
            }
        }
    }
});